import * as Highcharts from "highcharts";
import { observarRedimensionamento } from "../../../../utils/observarRedimensionamento";

require("highcharts/modules/exporting")(Highcharts);
require("highcharts/modules/export-data")(Highcharts);
require("highcharts/modules/no-data-to-display")(Highcharts);

export const ITENS_MENU_GRAFICO = [
  "viewFullscreen",
  "printChart",
  "separator",
  "downloadPNG",
  "downloadJPEG",
  "downloadPDF",
  "downloadSVG",
  "separator",
  "downloadCSV",
  "downloadXLS",
  "viewData",
];

export const IDIOMA_GRAFICO = {
  viewFullscreen: "Ver em tela cheia",
  printChart: "Imprimir gráfico",
  downloadPNG: "Baixar imagem PNG",
  downloadJPEG: "Baixar imagem JPEG",
  downloadPDF: "Baixar documento PDF",
  downloadSVG: "Baixar imagem vetorial SVG",
  downloadCSV: "Baixar CSV",
  downloadXLS: "Baixar XLS",
  viewData: "Ver tabela de dados",
  contextButtonTitle: "Menu do gráfico",
  loading: "Carregando...",
  noData: "Sem dados para exibir",
  resetZoom: "Desfazer zoom",
  resetZoomTitle: "Voltar ao zoom 1:1",
};

export const cabecalhoColunaExportada = (item: any) => {
  if (!item) {
    return "Categoria";
  }
  if (item.coll === "xAxis" && !(item.options.title && item.options.title.text)) {
    return item.isDatetimeAxis ? "Data" : "Categoria";
  }
  return false;
};

const DESCARTES = new WeakMap<Highcharts.Chart, () => void>();

Highcharts.addEvent(Highcharts.Chart, "load", function (this: Highcharts.Chart) {
  const grafico = this;
  const container = grafico.container && grafico.container.parentElement;
  if (!container) {
    return;
  }
  DESCARTES.set(
    grafico,
    observarRedimensionamento(container, () => {
      if (grafico.container) {
        grafico.reflow();
      }
    })
  );
});

Highcharts.addEvent(Highcharts.Chart, "destroy", function (this: Highcharts.Chart) {
  const descarta = DESCARTES.get(this);
  if (descarta) {
    descarta();
    DESCARTES.delete(this);
  }
});

Highcharts.setOptions({
  lang: IDIOMA_GRAFICO,
  exporting: {
    buttons: { contextButton: { menuItems: ITENS_MENU_GRAFICO } },
    csv: { columnHeaderFormatter: cabecalhoColunaExportada },
  } as Highcharts.ExportingOptions,
});
